/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterC = createReactComponent("circle-letter-c", "IconCircleLetterC", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", key: "svg-1" }]
]);

export { IconCircleLetterC as default };
//# sourceMappingURL=IconCircleLetterC.js.map
